import Ajax from '../../../../common/js/Ajax.js';
import Form from '../../../../common/js/form/Form.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import Widget from '../../../../common/js/Widget.js';

export default class LoginWidget extends Widget {

	constructor($widget) {
		super($widget);

		Form.onSubmit($widget, action => {
			Ajax.rpc('/login', {
				user: action.findField('user').val(),
				password: action.findField('password').val(),
				remember: action.findField('remember').is(':checked') ? true : false
			}, success => {
				if (success) {
					window.location.href = '/en/search';
				} else {
					action.error('Invalid user name or password');
				}
			}, error => {
				action.error('Failed to login', error);
			});
		});
	}

}
